<template>
  <el-tooltip :content="content" placement="top" :disabled="disabled">
    <div class="template-text-conent" ref="template-text-conent">
      <span class="template-text" ref="template-text">
        <slot />
      </span>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    content: { type: String, default: '' },
  },
  data() {
    return { disabled: false }
  },
  watch: {
    content() {
      this.loading()
    },
  },
  mounted() {
    this.loading()
  },
  methods: {
    loading() {
      const conent = this.$refs['template-text-conent']
      const text = this.$refs['template-text']

      if (!conent || !text) {
        setTimeout(() => {
          this.loading()
        }, 2000)
        return
      }

      const textWidth = text.offsetWidth
      const conentWidth = conent.offsetWidth
      this.disabled = textWidth <= conentWidth
    },
  },
}
</script>
<style lang="scss" scoped>
.template-text-conent {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
